import MessagePage from 'src/components/MessagePage';
import notFound from 'src/global/assets/icons/not-found.svg';

const NotFoundPage = () => {

  return (
    <MessagePage 
      title="Lo sentimos, la página que estas buscando no existe."
      buttonText="Ir a transacciones"
      buttonTo="/"
      imageSrc={notFound} 
    />
  );
};

export default NotFoundPage;
